import React, { Fragment, useState } from 'react';
import { useAsync } from 'react-async';
import { useHistory } from 'react-router';
import { createDivision } from '../../../api/services/divisionService';
import { ResponseStatus } from '../../../components/notifications';
import { FieldInput } from '../../../components/fieldInput';
import Layout from '../../../components/layout';
import SubmitButton from '../../../components/submitButton';

const CreateDivision = () => {
  const history = useHistory();

  // State
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  //const [visible, setVisible] = useState(true);

  const saveDivision = async () => {
    return await createDivision({
      name: name,
      description: description,
      isVisible: true,
    });
  };

  const save = useAsync({
    deferFn: saveDivision,
    onResolve: (r) => {
      history.push(`/admin/divisions`, {
        message: `"${name}" saved successfully!`,
      });
    },
  });

  return (
    <Fragment>
      <Layout>
        <Fragment>
          <ResponseStatus state={save} />
          <div>
            <div className='grid grid-cols-6 gap-6 mb-6'>
              {/*<div className='col-span-6 sm:col-span-6'>
                <div className='flex items-start'>
                  <div className='flex items-center h-5'>
                    <input
                      id='is-visible'
                      name='is-visible'
                      type='checkbox'
                      className='primary-checkbox'
                      checked={visible}
                      onChange={(e) => setVisible(e.currentTarget.checked)}
                    />
                  </div>
                  <div className='ml-3 text-sm'>
                    <label htmlFor='is-visible' className='primary'>
                      Active
                    </label>
                  </div>
                </div>
              </div>*/}
              <div className='col-span-6 sm:col-span-6'>
                <FieldInput
                  name='name'
                  label='Name'
                  minLength={1}
                  maxLength={150}
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                />
              </div>
              <div className='col-span-6 sm:col-span-6'>
                <div className='text-sm'>
                  <label className='primary'>Description<span className="text-red-500 pl-1">*</span></label>
                </div>
                <textarea
                  name='description'
                  minLength={1}
                  onChange={(e) => setDescription(e.target.value)}
                  value={description}
                />
              </div>
            </div>
          </div>

          <hr className='py-4' />

          <div className='text-right'>
            <SubmitButton
              text='Save Changes'
              disabled={name.length === 0 || description.length === 0}
              spinning={save.isPending}
              onClick={() => { save.run() }}
            />
          </div>
        </Fragment>
      </Layout>
    </Fragment>
  );
};

export default CreateDivision;
